(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/campaign/assets/shared/process-campaign-list-response.js') >= 0) return;  svs.modules.push('/components/numbergames/campaign/assets/shared/process-campaign-list-response.js');

'use strict';

function processCampaignListResponse() {
  let {
    campaigns
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (Array.isArray(campaigns)) {
    return campaigns.filter(campaign => campaign.drawStateId >= 2).map(_ref => {
      let {
        drawNumber,
        startDate,
        endDate,
        drawStateId,
        drawTypeId,
        products
      } = _ref;
      return {
        drawNumber,
        startDate,
        endDate,
        drawStateId,
        drawTypeId,
        products
      };
    });
  }
  return [];
}
if (typeof exports === 'object') {
  module.exports = processCampaignListResponse;
} else {
  svs.numbergames.campaign.shared.processCampaignListResponse = processCampaignListResponse;
}

 })(window);